<template>
	<Layout :loading="loading" :pageTitle="'Productos'">
		<template #cta>
			<router-link tag="a" to="/products/create" class="btn btn-primary">Crear producto</router-link>
		</template>
		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en productos"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div class="container-fluid">
			<div class="card mt-2">
				<div class="card-body">
					<draggable
						tag="table"
						class="table table-clickeable"
						v-model="list"
						handle=".handle"
						ghost-class="ghost"
						@change="sorted"
					>
						<tr class="table-head" slot="header">
							<td width="36"></td>
							<td>Producto</td>
							<td>Categoría</td>
							<td class="text-right">Precio</td>
							<td class="text-right">Stock</td>
							<td></td>
						</tr>

						<router-link
							tag="tr"
							:to="`${$route.path}/${item.id}`"
							v-for="(item, index) of list"
							:key="index"
						>
							<td>
								<div class="handle">
									<i class="icon icon-arrow-combo text-secondary"></i>
								</div>
							</td>
							<td>
								<div class="d-flex">
									<i class="icon icon-star mr-2" v-if="item.featured"></i>
									<i class="icon icon-star text-secondary mr-2" v-else></i>
									{{ item.name }}
								</div>
							</td>
							<td>
								<span v-if="item.category">
									{{ item.category.title }}
								</span>
							</td>
							<td class="text-right">
								<div v-if="item.salable && item.price > 0">U$S {{ item.price }}</div>
							</td>
							<td class="text-right">
								<div v-if="item.salable">{{ item.stockAvailable }}/{{ item.stock }}</div>
							</td>
							<td>
								<span class="d-flex justify-content-end">
									<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
									<span>{{ item.statusText }}</span>
								</span>
							</td>
						</router-link>
					</draggable>

					<div class="alert alert-light text-center mt-5" v-if="list.length == 0">
						No se han encontrado productos
					</div>

					<Pagination :pageData="pagination" @pageChange="pageChange" @pageLength="pageLength" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Products",
	data() {
		return {
			list: [],
			loading: false
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							products(take: $take, skip: $skip, search: $search) {
								data {
									id
									featured
									category {
										id
										title
									}
									name
									salable
									price
									stock
									stockAvailable
									order
									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.products.data
					this.pagination.pageInfo = data.products.pageInfo
					this.loading = false
				})
		},
		sorted(data) {
			if (data.moved) {
				var order = Math.max.apply(
					Math,
					this.list.map(function(o) {
						return o.order
					})
				)
				this.list.map((i) => {
					i.order = order
					order = order - 1
				})

				var list = this.list.map((i) => {
					return { id: i.id, order: i.order }
				})

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($list: [OrderList]!) {
								productSort(list: $list)
							}
						`,
						variables: {
							list
						}
					})
					.then(() => {
						this.$toast.success("Listado actualizado")
					})
					.catch((error) => {
						this.parseGQLErrors(error)
					})
			}
		}
	}
}
</script>

<style>
.ghost {
	background-color: #f3f3f3 !important;
}
</style>
